import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';
import Feather from '@expo/vector-icons/Feather';
import { Paprika } from '../../styles/theme';

/**
 * Credit line for filters the model inferred.
 *
 * The caller must only render this when at least one token actually came from
 * the model. It used to appear above any filter at all, so Paprika claimed to
 * have "understood" chips the user had tapped themselves.
 */
export const UnderstoodLine: React.FC = () => {
  const { t } = useTranslation();
  return (
    <View style={styles.row}>
      <Feather name="zap" size={13} color={Paprika.ai} />
      <Text style={styles.text}>{t('recipes.understoodLine')}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    marginBottom: 8,
  },
  text: {
    fontFamily: 'Inter-Regular',
    fontSize: 12,
    color: Paprika.textMuted,
    fontStyle: 'italic',
    flex: 1,
  },
});
